export default function ListData({
  items = [],
  renderItem,
  currentItemId = null,
  onItemClick,
  emptyMessage = "No items to display",
  className = "",

  layout = "list", // "list" | "grid"
  containerClassName = "",
  itemClassName = "",
  /** For list layout only: override container base class (e.g. divide-y bordered list). */
  listContainerClass = "",
  /** For list layout only: class when item is selected. */
  listSelectedClass = "",
  /** For list layout only: class when item is not selected. */
  listUnselectedClass = "",
  /*For list layout only: when set, replaces the default row shell (rounded bordered cards). Use with listContainerClass e.g. divide-y for flat rows like practitioner lists.
   */
  listItemBaseClass = "",
}) {
  if (items.length === 0) {
    return <div className="text-center py-8 text-smiles-lightGray">{emptyMessage}</div>;
  }

  const isGrid = layout === "grid";
  const listBase = listContainerClass || "space-y-2";

  const containerCls = isGrid
    ? `grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${containerClassName}`
    : `${listBase} ${containerClassName}`.trim();

  const clickable = typeof onItemClick === "function";

  const handleItemKeyDown = (e, item) => {
    if (!clickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onItemClick?.(item);
    }
  };

  // Default list rows: bordered cards. Optional listItemBaseClass overrides this (e.g. no per-row border when the container uses divide-y).
  const defaultListItemBase = `group flex items-center justify-between p-3 rounded-lg border transition-colors${clickable ? " cursor-pointer" : ""}`;

  const itemBaseCls = isGrid
    ? `group rounded-xl border border-palette-gray-divider bg-white p-4 transition hover:shadow-sm${clickable ? " cursor-pointer" : ""}`
    : listItemBaseClass || defaultListItemBase;

  const listSelected = listSelectedClass || "bg-palette-indigo-soft border-palette-indigo-border";
  const listUnselected =
    listUnselectedClass || "bg-white border-palette-gray-divider hover:bg-palette-gray-soft";

  return (
    <div className={`${containerCls} ${className}`}>
      {items.map((item) => {
        const isCurrentItem = currentItemId != null && String(item.id) === String(currentItemId);

        const listStateCls = isGrid
          ? isCurrentItem
            ? "ring-2 ring-palette-indigo-border border-palette-indigo-border"
            : "hover:bg-palette-gray-soft"
          : isCurrentItem
            ? listSelected
            : listUnselected;

        return (
          <div
            key={item.id}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            className={`${itemBaseCls} ${listStateCls} ${itemClassName}`}
            onClick={() => onItemClick?.(item)}
            onKeyDown={(e) => handleItemKeyDown(e, item)}
          >
            {renderItem(item, isCurrentItem)}
          </div>
        );
      })}
    </div>
  );
}
